/** Preços por projeto — Convites Digitais (não assinatura). */

export const DIGITAL_INVITES_PLAN_PRICES = {
  start: {
    project: { BRL: 97, EUR: 19, USD: 24 }
  },
  premium: {
    project: { BRL: 297, EUR: 49, USD: 59 }
  },
  experience: {
    project: { BRL: 697, EUR: 119, USD: 149 },
    plus: true
  }
};

/** Preços por modelo do catálogo (página Convites Digitais) — EUR + BRL oficiais. */
export const DIGITAL_INVITES_CATALOG_PRICES = {
  simple: { EUR: 5, BRL: 25 },
  interactive: { EUR: 10, BRL: 55 },
  interactiveInfinite: { EUR: 20, BRL: 120 },
  gifAnimated: { EUR: 10, BRL: 55 },
  animated: { EUR: 10, BRL: 55 },
  superAnimated: { EUR: 25, BRL: 180 },
  sweet15: { EUR: 25, BRL: 150 },
  kidsCharacter: { EUR: 35, BRL: 250 },
  weddingPremium: { EUR: 25, BRL: 150 },
  babyRevealSimple: { EUR: 10, BRL: 55 },
  babyRevealInteractive: { EUR: 10, BRL: 55 },
  babyRevealPremiumWebsite: { EUR: 35, BRL: 250 }
};

export function getDefaultDigitalInvitesCurrency(language) {
  if (language === 'pt-BR') return 'BRL';
  if (language === 'pt-PT') return 'EUR';
  return 'USD';
}

const formatterCache = new Map();

function getNumberFormatter(locale, fractionDigits = 0) {
  const key = `${locale}-${fractionDigits}`;
  if (!formatterCache.has(key)) {
    formatterCache.set(
      key,
      new Intl.NumberFormat(locale, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      })
    );
  }
  return formatterCache.get(key);
}

export function formatDigitalInvitesPlanPrice(amount, currency, opts = {}) {
  const { plus = false, language = 'pt-BR' } = opts;
  const suffix = plus ? '+' : '';
  const n = getNumberFormatter(
    currency === 'BRL' ? 'pt-BR' : currency === 'EUR' ? 'pt-PT' : 'en-US'
  ).format(amount);

  if (currency === 'BRL') return `R$ ${n}${suffix}`;
  if (currency === 'EUR') return `${n} €${suffix}`;
  return `US$ ${n}${suffix}`;
}

export function formatCatalogBrlPrice(amount) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(amount);
}

export function formatCatalogEurPrice(amount) {
  return `${amount} €`;
}

export function getDigitalInvitesPlanPrice(planKey, currency, language) {
  const plan = DIGITAL_INVITES_PLAN_PRICES[planKey];
  if (!plan) return null;
  const amount = plan.project?.[currency];
  if (amount == null) return null;
  return {
    amount,
    label: formatDigitalInvitesPlanPrice(amount, currency, { plus: !!plan.plus, language })
  };
}

/** Exibe preço principal + secundário (EUR / BRL conforme referência comercial). */
export function getDigitalInvitesCatalogPriceDisplay(modelKey, language) {
  const plan = DIGITAL_INVITES_CATALOG_PRICES[modelKey];
  if (!plan) return { custom: true };

  const brlLabel = formatCatalogBrlPrice(plan.BRL);
  const eurLabel = formatCatalogEurPrice(plan.EUR);

  if (language === 'pt-BR') {
    return { primary: brlLabel, secondary: eurLabel, custom: false };
  }
  return { primary: eurLabel, secondary: brlLabel, custom: false };
}
